import AddNoteModal from 'components/GlobalModals/AddNoteModal/AddNoteModal';

export default AddNoteModal;
